import React from 'react';
import { Tag, Icon } from 'antd';
import { useTranslation } from 'react-i18next';

const NewScreenTag = ({ style }) => {
  const { t } = useTranslation();

  return (
    <Tag color="orange" style={style}>
      <Icon type="desktop" />{' '}
      {t('New screen')}
    </Tag>
  );
};

export default NewScreenTag;
